import React, { useCallback, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useVariables } from '../../../../providers/VariableProvider'
import Select from '../../../molecules/Select'

export const options = [
  { label: 'Previous Day', value: 'day' },
  { label: 'Week to Date', value: 'wtd' },
  { label: 'Month to Date', value: 'mtd' },
  { label: 'Quarter to Date', value: 'qtd' },
  { label: 'Year to Date', value: 'ytd' },
  { label: 'Year', value: 'one year' },
  { label: '2 Years', value: 'two year' },
  { label: '3 Years', value: 'three year' },
  { label: '4 Years', value: 'four year' },
  { label: '5 Years', value: 'five year' },
  { label: '6 Years', value: 'six year' },
  { label: '7 Years', value: 'seven year' },
  { label: '8 Years', value: 'eight year' },
  { label: '9 Years', value: 'nine year' },
  { label: '10 Years', value: 'ten year' },
  { label: 'Since Inception', value: 'inception' },
  { label: 'Holding Period', value: 'holding period' },
  { label: 'Custom', value: 'custom' }
]

function PipelineQuickDatePicker ({ applyTo, defaultValue, className, availableDateRanges, style }) {
  const { setVariable, getVariable } = useVariables()
  const setValue = useCallback((value) => {
    setVariable(applyTo, value)
  }, [setVariable, applyTo])

  // This sets the default variable value. Open to other ways to do this.
  useEffect(() => {
    if (getVariable(applyTo) === undefined) {
      setVariable(applyTo, defaultValue)
    }
  }, [setVariable, getVariable, applyTo, defaultValue])

  const dateRangeOptions = useMemo(
    () => options.filter(option =>
      availableDateRanges ? availableDateRanges.includes(option.value) : option.value !== 'custom'
    ),
    [availableDateRanges]
  )

  return (
    <Select
      className={className}
      style={style}
      options={dateRangeOptions}
      value={getVariable(applyTo, defaultValue)}
      onChange={setValue}
    />
  )
}

PipelineQuickDatePicker.propTypes = {
  applyTo: PropTypes.string,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  availableDateRanges: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object
}

PipelineQuickDatePicker.defaultProps = {
  applyTo: 'quickDate',
  defaultValue: 'ytd'
}

export default PipelineQuickDatePicker
